export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;

// Mirrors the Cognito User Pool's actual password policy — keep in sync if
// that policy ever changes, so the client never rejects (or silently allows)
// something the server disagrees with.
export const PASSWORD_REQUIREMENTS = [
  { key: "number", label: "Contains at least 1 number", test: (p) => /\d/.test(p) },
  { key: "uppercase", label: "Contains at least 1 uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { key: "lowercase", label: "Contains at least 1 lowercase letter", test: (p) => /[a-z]/.test(p) },
];

export function isValidPassword(password) {
  const length = password?.length ?? 0;
  if (length < PASSWORD_MIN_LENGTH || length > PASSWORD_MAX_LENGTH) return false;
  return PASSWORD_REQUIREMENTS.every((req) => req.test(password));
}

/** One-line summary of what's required, e.g. under a password field. */
export function getPasswordRequirementsSentence() {
  const rules = PASSWORD_REQUIREMENTS.map((req) => req.label.replace(/^Contains at least /i, ""));
  const rulesText =
    rules.length > 1
      ? `${rules.slice(0, -1).join(", ")}, and ${rules[rules.length - 1]}`
      : rules[0];
  return `Password must be ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters and contain ${rulesText}.`;
}

export function getPasswordError(password, fieldLabel = "Password") {
  const length = password?.length ?? 0;
  if (!length) return `${fieldLabel} is required`;
  if (length < PASSWORD_MIN_LENGTH) {
    return `${fieldLabel} must be at least ${PASSWORD_MIN_LENGTH} characters`;
  }
  if (length > PASSWORD_MAX_LENGTH) {
    return `${fieldLabel} must be at most ${PASSWORD_MAX_LENGTH} characters`;
  }
  const missed = PASSWORD_REQUIREMENTS.find((req) => !req.test(password));
  if (missed) {
    const rule = missed.label.replace(/^Contains /i, "contain ");
    return `${fieldLabel} must ${rule.charAt(0).toLowerCase()}${rule.slice(1)}`;
  }
  return "";
}

/** Sign-in only checks that a password was entered. Strength rules belong to signup and reset. */
export function getLoginPasswordError(password, fieldLabel = "Password") {
  const length = password?.length ?? 0;
  if (!length) return `${fieldLabel} is required`;
  return "";
}
